import React from 'react';
import { Helmet } from 'react-helmet';
import Seo from '../../components/Seo';
import HeaderTwo from '../../components/header/HeaderTwo';
import BreadCrumb from './BreadCrumb';
import Footer from '../../components/footer/Footer';

import OATTMMusic from './OATTMMusic';


function AiMusic() {
  return (
	<>
	<Helmet>
		<link rel="canonical" href="https://oliverandthetimemachine.com/music" />
		<title>OATTM - 	Music and soundtracks from the book series</title>
		<meta name="description" content="Music from the Oliver and the Time Machine series. ChapterVerse is a journey of music following each chapter of the books." />
	</Helmet>
	<Seo 
		title="OATTM – Music and soundtracks from the book series"
		description="Music from the Oliver and the Time Machine series. ChapterVerse is a journey of music following each chapter of the books."
		url="/music"
	/>
	<HeaderTwo/>
	<BreadCrumb/>
	<main>
	<OATTMMusic/>
	</main>
	<Footer/>
	</>
  )
}

export default AiMusic